import { CHAIN_KEYS } from './interfaces';

const parseBoolean = value => String(value).toLowerCase() === 'true';

const ethereumStablecoins = {
  USDT: {
    key: 'USDT',
    name: 'USDT',
    fullName: 'Tether USD',
    address: process.env.REACT_APP_ETH_USDT_ADDRESS || '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
  },
  USDC: {
    key: 'USDC',
    name: 'USDC',
    fullName: 'USD Coin',
    address: process.env.REACT_APP_ETH_USDC_ADDRESS || '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
  },
  DAI: {
    key: 'DAI',
    name: 'DAI',
    fullName: 'Dai Stablecoin',
    address: process.env.REACT_APP_ETH_DAI_ADDRESS || '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    decimals: 18,
  },
};

const bscStablecoins = {
  USDT: {
    key: 'USDT',
    name: 'USDT',
    fullName: 'Tether USD',
    address: process.env.REACT_APP_BSC_USDT_ADDRESS || '0x55d398326f99059fF775485246999027B3197955',
    decimals: 18,
  },
  USDC: {
    key: 'USDC',
    name: 'USDC',
    fullName: 'USD Coin',
    address: process.env.REACT_APP_BSC_USDC_ADDRESS || '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    decimals: 18,
  },
  DAI: {
    key: 'DAI',
    name: 'DAI',
    fullName: 'Dai Stablecoin',
    address: process.env.REACT_APP_BSC_DAI_ADDRESS || '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    decimals: 18,
  },
};

const adiStablecoins = {
  ...(process.env.REACT_APP_ADI_USDT_ADDRESS
    ? {
        USDT: {
          key: 'USDT',
          name: 'USDT',
          fullName: 'Tether USD',
          address: process.env.REACT_APP_ADI_USDT_ADDRESS,
          decimals: Number(process.env.REACT_APP_ADI_USDT_DECIMALS || 6),
        },
      }
    : {}),
  ...(process.env.REACT_APP_ADI_USDC_ADDRESS
    ? {
        USDC: {
          key: 'USDC',
          name: 'USDC',
          fullName: 'USD Coin',
          address: process.env.REACT_APP_ADI_USDC_ADDRESS,
          decimals: Number(process.env.REACT_APP_ADI_USDC_DECIMALS || 6),
        },
      }
    : {}),
};

const solanaStablecoins = {
  USDT: {
    key: 'USDT',
    name: 'USDT',
    fullName: 'Tether USD (SPL)',
    mint: process.env.REACT_APP_SOL_USDT_MINT || 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    decimals: 6,
    tokenProgramId:
      process.env.REACT_APP_SOL_USDT_TOKEN_PROGRAM_ID ||
      'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
  },
  USDC: {
    key: 'USDC',
    name: 'USDC',
    fullName: 'USD Coin (SPL)',
    mint: process.env.REACT_APP_SOL_USDC_MINT || 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    decimals: 6,
    tokenProgramId:
      process.env.REACT_APP_SOL_USDC_TOKEN_PROGRAM_ID ||
      'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
  },
};

const SOLANA_MAINNET_USDN_MINT = 'CZzgUBvxaMLwMhVSLgqJn3npmxoTo6nzMNQPAnwtHF3s';
const SOLANA_MAINNET_USDN_TOKEN_PROGRAM_ID = 'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb';
const SOLANA_MAINNET_TREASURY_SWAP_PROGRAM_ID = '3S33zyqGFLx6i9x8kMS2fUyCA2XKR4qKw48a4LfwnU9P';
const SOLANA_MAINNET_SWAP_ROUTER_PROGRAM_ID = 'Af18d9ca3yZMLU5eg6EXRvYbAC5zzwXhtgFAcR319WDp';
const SOLANA_MAINNET_TREASURY_USDN_ACCOUNT = 'Cm1hqUyXwwX3Mkr1g8D6nn7LuuaBD2QHY8XhaWeSNHpF';
const SOLANA_TREASURY_SWAP_DISCRIMINATOR = 'f8c69e91e17587c8';
// USDN uses the same address on Ethereum and BSC.
const USDN_MAINNET_ADDRESS = '0xeC747DAf41A4Ca4ebE72356592F8301924132907';
// Ethereum swap contract for USDN; it is also the approval target.
const ETH_MAINNET_SWAP_CONTRACT_ADDRESS = '0x08022339cF6C27458268c20914D18a0D73d28259';
const ETH_MAINNET_RPC_FALLBACK_URLS = [process.env.REACT_APP_ETH_RPC_FALLBACK_URL].filter(Boolean);

export const chainRegistry = {
  [CHAIN_KEYS.ETHEREUM]: {
    key: CHAIN_KEYS.ETHEREUM,
    adapter: 'evm',
    name: 'Ethereum',
    networkLabel: process.env.REACT_APP_ETH_NETWORK_LABEL || 'Ethereum Mainnet',
    networkId: String(process.env.REACT_APP_CHAIN_ID || '1'),
    rpcUrl: process.env.REACT_APP_ETH_RPC_URL || 'https://eth-mainnet.public.blastapi.io',
    rpcFallbackUrls: ETH_MAINNET_RPC_FALLBACK_URLS,
    explorerBaseUrl: process.env.REACT_APP_ETH_EXPLORER_URL || 'https://etherscan.io/tx/',
    usdnAddress: process.env.REACT_APP_USDN_ADDRESS || USDN_MAINNET_ADDRESS,
    swapContractAddress:
      process.env.REACT_APP_SWAP_CONTRACT_ADDRESS || ETH_MAINNET_SWAP_CONTRACT_ADDRESS,
    approveContractAddress:
      process.env.REACT_APP_APPROVE_CONTRACT_ADDRESS || ETH_MAINNET_SWAP_CONTRACT_ADDRESS,
    stablecoins: ethereumStablecoins,
    features: {
      requiresApproval: true,
      supportsSimulation: true,
      supportsNetworkSwitch: true,
    },
  },
  [CHAIN_KEYS.BSC]: {
    key: CHAIN_KEYS.BSC,
    adapter: 'evm',
    name: 'BSC',
    networkLabel: process.env.REACT_APP_BSC_NETWORK_LABEL || 'BSC Mainnet',
    networkId: String(process.env.REACT_APP_BSC_CHAIN_ID || '56'),
    rpcUrl: process.env.REACT_APP_BSC_RPC_URL || 'https://bsc-dataseed.bnbchain.org',
    rpcFallbackUrls: [process.env.REACT_APP_BSC_RPC_FALLBACK_URL].filter(Boolean),
    explorerBaseUrl: process.env.REACT_APP_BSC_EXPLORER_URL || 'https://bscscan.com/tx/',
    blockExplorerUrl: process.env.REACT_APP_BSC_BLOCK_EXPLORER_URL || 'https://bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    usdnAddress: process.env.REACT_APP_BSC_USDN_ADDRESS || USDN_MAINNET_ADDRESS,
    // No USDN swap contract is deployed on BSC yet, so there is deliberately
    // no default: BSC stays unconfigured for swaps (and out of the selector)
    // until REACT_APP_BSC_SWAP_CONTRACT_ADDRESS is supplied.
    swapContractAddress: process.env.REACT_APP_BSC_SWAP_CONTRACT_ADDRESS || '',
    approveContractAddress:
      process.env.REACT_APP_BSC_APPROVE_CONTRACT_ADDRESS ||
      process.env.REACT_APP_BSC_SWAP_CONTRACT_ADDRESS ||
      '',
    stablecoins: bscStablecoins,
    features: {
      requiresApproval: true,
      supportsSimulation: true,
      supportsNetworkSwitch: true,
    },
  },
  [CHAIN_KEYS.ADI]: {
    key: CHAIN_KEYS.ADI,
    adapter: 'evm',
    name: 'ADI',
    networkLabel: process.env.REACT_APP_ADI_NETWORK_LABEL || 'ADI Network',
    networkId: String(process.env.REACT_APP_ADI_CHAIN_ID || '36900'),
    rpcUrl: process.env.REACT_APP_ADI_RPC_URL || 'https://rpc.adifoundation.ai/',
    explorerBaseUrl:
      process.env.REACT_APP_ADI_EXPLORER_URL || 'https://explorer.adifoundation.ai/tx/',
    blockExplorerUrl:
      process.env.REACT_APP_ADI_BLOCK_EXPLORER_URL || 'https://explorer.adifoundation.ai',
    nativeCurrency: {
      name: 'ADI',
      symbol: 'ADI',
      decimals: 18,
    },
    usdnAddress: process.env.REACT_APP_ADI_USDN_ADDRESS || '',
    swapContractAddress: process.env.REACT_APP_ADI_SWAP_CONTRACT_ADDRESS || '',
    approveContractAddress: process.env.REACT_APP_ADI_APPROVE_CONTRACT_ADDRESS || '',
    stablecoins: adiStablecoins,
    features: {
      requiresApproval: true,
      supportsSimulation: true,
      supportsNetworkSwitch: true,
    },
  },
  [CHAIN_KEYS.SOLANA]: {
    key: CHAIN_KEYS.SOLANA,
    adapter: 'solana',
    name: 'Solana',
    networkLabel: process.env.REACT_APP_SOLANA_NETWORK_LABEL || 'Solana Mainnet',
    networkId: process.env.REACT_APP_SOLANA_CLUSTER || 'mainnet-beta',
    rpcUrl: process.env.REACT_APP_SOLANA_RPC_URL || 'https://solana-rpc.publicnode.com',
    explorerBaseUrl: process.env.REACT_APP_SOLANA_EXPLORER_URL || 'https://explorer.solana.com/tx/',
    explorerClusterQuery: process.env.REACT_APP_SOLANA_EXPLORER_CLUSTER_QUERY || '',
    usdnMint: process.env.REACT_APP_SOL_USDN_MINT || SOLANA_MAINNET_USDN_MINT,
    usdnTokenProgramId:
      process.env.REACT_APP_SOL_USDN_TOKEN_PROGRAM_ID || SOLANA_MAINNET_USDN_TOKEN_PROGRAM_ID,
    treasurySwapProgramId:
      process.env.REACT_APP_SOL_TREASURY_SWAP_PROGRAM_ID || SOLANA_MAINNET_TREASURY_SWAP_PROGRAM_ID,
    swapRouterProgramId:
      process.env.REACT_APP_SOL_SWAP_ROUTER_PROGRAM_ID || SOLANA_MAINNET_SWAP_ROUTER_PROGRAM_ID,
    swapProgramId:
      process.env.REACT_APP_SOL_SWAP_PROGRAM_ID ||
      process.env.REACT_APP_SOL_TREASURY_SWAP_PROGRAM_ID ||
      SOLANA_MAINNET_TREASURY_SWAP_PROGRAM_ID,
    treasuryUsdnAccount:
      process.env.REACT_APP_SOL_TREASURY_USDN_ACCOUNT || SOLANA_MAINNET_TREASURY_USDN_ACCOUNT,
    instructionDiscriminatorHex:
      process.env.REACT_APP_SOL_SWAP_INSTRUCTION_DISCRIMINATOR ||
      SOLANA_TREASURY_SWAP_DISCRIMINATOR,
    readinessMessage:
      'Solana mainnet is wired, but production enablement still requires a successful mainnet smoke swap.',
    stablecoins: solanaStablecoins,
    features: {
      requiresApproval: false,
      supportsSimulation: true,
      supportsNetworkSwitch: false,
    },
  },
};

export const isChainEnabled = chainKey => {
  if (chainKey === CHAIN_KEYS.SOLANA) {
    return parseBoolean(process.env.REACT_APP_ENABLE_SOLANA || 'false');
  }
  if (chainKey === CHAIN_KEYS.BSC) {
    return parseBoolean(process.env.REACT_APP_ENABLE_BSC || 'false');
  }
  if (chainKey === CHAIN_KEYS.ADI) {
    return parseBoolean(process.env.REACT_APP_ENABLE_ADI || 'true');
  }
  return true;
};

export const isChainConfiguredForSwap = chain => {
  if (!chain) return false;
  if (chain.adapter === 'evm') {
    return Boolean(
      chain.usdnAddress &&
      chain.swapContractAddress &&
      chain.approveContractAddress &&
      Object.values(chain.stablecoins || {}).some(token => token.address)
    );
  }
  if (chain.adapter === 'solana') {
    return Boolean(
      chain.usdnMint &&
      chain.usdnTokenProgramId &&
      chain.swapProgramId &&
      chain.instructionDiscriminatorHex &&
      Object.values(chain.stablecoins || {}).some(token => token.mint && token.tokenProgramId)
    );
  }
  return true;
};

export const getEnabledChains = () =>
  Object.values(chainRegistry).filter(
    chain => isChainEnabled(chain.key) && isChainConfiguredForSwap(chain)
  );

/**
 * Chains advertised in the chain selector as "coming soon" (disabled).
 * TRON has no registry entry yet, so it uses a display-only key.
 */
export const COMING_SOON_CHAINS = [
  { key: CHAIN_KEYS.BSC, name: 'BNB Chain' },
  { key: CHAIN_KEYS.SOLANA, name: 'Solana' },
  { key: 'tron', name: 'TRON' },
  { key: CHAIN_KEYS.ADI, name: 'ADI' },
];

/** Coming-soon chains minus any that are enabled in this build. */
export const getComingSoonChains = (enabledChains = getEnabledChains()) =>
  COMING_SOON_CHAINS.filter(soon => !enabledChains.some(chain => chain.key === soon.key));

export const getChainConfig = chainKey => chainRegistry[chainKey];

export const getEnabledEvmChainKeyByNetworkId = networkId => {
  const normalizedNetworkId = String(networkId || '');
  if (!normalizedNetworkId) return '';
  const match = getEnabledChains().find(
    chain => chain.adapter === 'evm' && String(chain.networkId) === normalizedNetworkId
  );
  return match?.key || '';
};

export const getDefaultChainKey = () => {
  const envChain = process.env.REACT_APP_DEFAULT_CHAIN;
  if (
    envChain &&
    chainRegistry[envChain] &&
    isChainEnabled(envChain) &&
    isChainConfiguredForSwap(chainRegistry[envChain])
  ) {
    return envChain;
  }
  return getEnabledChains()[0]?.key || CHAIN_KEYS.ETHEREUM;
};

export const getExplorerTxUrl = (chainKey, txHash) => {
  const chain = getChainConfig(chainKey);
  if (!chain || !txHash) return '';
  if (chainKey === CHAIN_KEYS.SOLANA) {
    return `${chain.explorerBaseUrl}${txHash}${chain.explorerClusterQuery || ''}`;
  }
  return `${chain.explorerBaseUrl}${txHash}`;
};
